// // Fixed LeadList.js - Using ModalNotification properly
// import React, { useState, useEffect, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaEdit, FaTrash, FaSms, FaPhoneAlt, FaMapMarkerAlt, FaBuilding, FaInbox, FaSortAlphaDown, FaSortAlphaUp, FaSort, FaEye, FaArrowRight } from 'react-icons/fa';
// import { getLeads, deleteLead } from './leadService';
// import Pagination from '../../components/shared/Pagination';
// import Modal from '../../components/shared/Modal';
// import DashboardLayout from '../../layouts/DashboardLayout';
// import formatPhone from '../../components/shared/formatPhone';
// import SmsModal from './SmsModal';
// import FeedbackModal from '../../components/shared/ModalNotification'; // Import ModalNotification
// import { StatusBadge, ResponsiveHeader } from '../../components/styled/CommonStyles';
// import { GridContainer,Card,CardHeader,LeadName,CardContent,InfoRow,ActionIconsContainer,ActionButton,EmptyState,FilterGroup,FilterLabel,FilterButton,FilterSection, DescriptionContainer} from '../../components/styled/GridComponents';
// import LoadingSpinner from '../../components/shared/LoadingSpinner';
// import CallModal from '../../components/shared/CallModal';

// const LeadList = ({ userId }) => {
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [leadToDelete, setLeadToDelete] = useState(null);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [filteredLeads, setFilteredLeads] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(12);
//   const [smsModalOpen, setSmsModalOpen] = useState(false);
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [sortConfig, setSortConfig] = useState({ field: 'name', direction: 'asc' });
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [availableStatuses, setAvailableStatuses] = useState([]);

//   // NEW: State for CallModal
//   const [callModalOpen, setCallModalOpen] = useState(false);
//   const [leadToCall, setLeadToCall] = useState(null);


//   // ModalNotification state
//   const [showFeedback, setShowFeedback] = useState(false);
//   const [feedbackMessage, setFeedbackMessage] = useState('');
//   const [feedbackSuccess, setFeedbackSuccess] = useState(true);

//   const navigate = useNavigate();

//   // Function to show notifications using ModalNotification
//   const showNotification = (message, isSuccess = true) => {
//     setFeedbackMessage(message);
//     setFeedbackSuccess(isSuccess);
//     setShowFeedback(true);
//   };

//   const handleFeedbackComplete = () => {
//     setShowFeedback(false);
//   };

//   // Click-to-call handlers
//   const handleCallInitiated = (callData) => {
//     showNotification('Call initiated! Your phone will ring momentarily.', true);
//   };

//   const handleCallError = (error) => {
//     showNotification(`Call failed: ${error.message}`, false);
//   };

//   useEffect(() => {
//     const fetchLeads = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const leadsData = await getLeads();
//         setLeads(leadsData);
//         setFilteredLeads(leadsData);
//       } catch (error) {
//         console.error('Error fetching leads:', error);
//         setError('Failed to load leads. Please try again.');
//         showNotification('Failed to load leads. Please try again.', false);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchLeads();
//   }, []);

//   useEffect(() => {
//     if (!leads) return;
//     const filtered = leads.filter((lead) => {
//       const searchLower = searchQuery.toLowerCase();
//       return (
//         lead.name?.toLowerCase().includes(searchLower) ||
//         lead.city?.toLowerCase().includes(searchLower) ||
//         lead.phone?.includes(searchLower)
//       );
//     });
//     if (leads.length > 0) {
//       const statuses = new Set(leads.map(lead => 
//         lead.serviceRequests?.[0]?.LeadStatus?.status_name || 'No Status'
//       ));
//       setAvailableStatuses(['all', ...Array.from(statuses)]);
//     }
//     setFilteredLeads(filtered);
//     setCurrentPage(1);
//   }, [searchQuery, leads]);

//   const handleDelete = async () => {
//     try {
//       await deleteLead(leadToDelete);
//       const updatedLeads = await getLeads();
//       setLeads(updatedLeads);
//       setFilteredLeads(updatedLeads);
//       showNotification('Lead deleted successfully.', true);
//     } catch (error) {
//       showNotification('Failed to delete lead. Please try again.', false);
//     } finally {
//       setDeleteModalOpen(false);
//       setLeadToDelete(null);
//     }
//   };

//   // NEW: Handle call button click
//   const handleCallClick = (lead) => {
//     setLeadToCall(lead);
//     setCallModalOpen(true);
//   };

//   // NEW: Handle successful call initiation
//   const handleCallSuccess = (callResult) => {
//     console.log('Call initiated successfully:', callResult);
//     // Optionally show a success notification here
//     // You can also refresh the lead data if needed
//   };

//   const filteredAndSortedLeads = useMemo(() => {
//     let filtered = leads.filter((lead) => {
//       const matchesSearch = 
//         lead.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         lead.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         lead.phone.includes(searchQuery);

//       const matchesStatus = 
//         statusFilter === 'all' ||
//         (statusFilter === 'No Status' && !lead.serviceRequests?.[0]?.LeadStatus?.status_name) ||
//         lead.serviceRequests?.[0]?.LeadStatus?.status_name === statusFilter;

//       return matchesSearch && matchesStatus;
//     });

//     return filtered.sort((a, b) => {
//       let aValue, bValue;
      
//       switch (sortConfig.field) {
//         case 'name':
//           aValue = a.name;
//           bValue = b.name;
//           break;
//         case 'city':
//           aValue = a.city;
//           bValue = b.city;
//           break;
//         case 'status':
//           aValue = a.serviceRequests?.[0]?.LeadStatus?.status_name || 'No Status';
//           bValue = b.serviceRequests?.[0]?.LeadStatus?.status_name || 'No Status';
//           break;
//         case 'date':
//           aValue = a.createdAt;
//           bValue = b.createdAt;
//           break;
//         default:
//           aValue = a[sortConfig.field];
//           bValue = b[sortConfig.field];
//       }

//       if (sortConfig.direction === 'asc') {
//         return aValue.localeCompare(bValue);
//       } else {
//         return bValue.localeCompare(aValue);
//       }
//     });
//   }, [leads, searchQuery, statusFilter, sortConfig]);

//   const currentLeads = filteredAndSortedLeads.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleSort = (field) => {
//     setSortConfig(prevConfig => ({
//       field,
//       direction: prevConfig.field === field && prevConfig.direction === 'asc' ? 'desc' : 'asc'
//     }));
//   };

//   return ( 
//     <DashboardLayout>
//       <ResponsiveHeader
//         title="Leads Management"
//         onSearch={setSearchQuery}
//         onAdd={() => navigate('/leads/new')}
//       />

//       {loading ? (
//         <LoadingSpinner />
//       ) : (
//         <>
//       <FilterSection>
//         <FilterGroup>
//           <FilterLabel>Sort by:</FilterLabel>
//           <FilterButton 
//             isActive={sortConfig.field === 'date'}
//             onClick={() => handleSort('date')}
//           >
//             {sortConfig.field === 'date' ? 
//               (sortConfig.direction === 'asc' ? <FaSortAlphaDown /> : <FaSortAlphaUp />) 
//               : <FaSort />
//             }
//             Date
//           </FilterButton>
//           <FilterButton 
//             isActive={sortConfig.field === 'name'}
//             onClick={() => handleSort('name')}
//           >
//             {sortConfig.field === 'name' ? 
//               (sortConfig.direction === 'asc' ? <FaSortAlphaDown /> : <FaSortAlphaUp />) 
//               : <FaSort />
//             }
//             Name
//           </FilterButton>
//           <FilterButton 
//             isActive={sortConfig.field === 'city'}
//             onClick={() => handleSort('city')}
//           >
//             {sortConfig.field === 'city' ? 
//               (sortConfig.direction === 'asc' ? <FaSortAlphaDown /> : <FaSortAlphaUp />) 
//               : <FaSort />
//             }
//             City
//           </FilterButton>
//         </FilterGroup>

//         <FilterGroup>
//           <FilterLabel>Status:</FilterLabel>
//           {availableStatuses.map(status => (
//             <FilterButton
//               key={status}
//               isActive={statusFilter === status}
//               onClick={() => setStatusFilter(status)}
//             >
//               {status === 'all' ? 'All' : status}
//             </FilterButton>
//           ))}
//         </FilterGroup>
//       </FilterSection>

//       <GridContainer>
//         {loading ? (
//           [...Array(6)].map((_, index) => (
//             <Card key={index} isLoading>
//               <CardContent />
//             </Card>
//           ))
//         ) : currentLeads.length === 0 ? (
//           <EmptyState>
//             <FaInbox size={48} />
//             <p>No leads found. Try adjusting your search or add a new lead.</p>
//           </EmptyState>
//         ) : (
//           currentLeads.map((lead) => (
//             <Card key={lead.id}>
//               <CardHeader>
//                 <LeadName>{lead.name}</LeadName>
//                 <StatusBadge color={lead.serviceRequests?.[0]?.LeadStatus?.color || "#999"}>
//                   {lead.serviceRequests?.[0]?.LeadStatus?.status_name || "No Status"}
//                 </StatusBadge>
//               </CardHeader>

//               <CardContent>
//                 <InfoRow>
//                   <FaMapMarkerAlt />
//                   <span>{lead.city}</span>
//                 </InfoRow>
                
//                 <InfoRow>
//                   <FaPhoneAlt />
//                   <span>{formatPhone(lead.phone)}</span>
//                 </InfoRow>
                
//                 {lead.email && (
//                   <InfoRow>
//                     <FaBuilding />
//                     <span>{lead.email}</span>
//                   </InfoRow>
//                 )}
//               </CardContent>
              
//               {lead.serviceRequests && lead.serviceRequests.map((sreq) => (
//                 <DescriptionContainer key={sreq.id}>
//                   {Array.isArray(sreq.Service) ? (
//                     sreq.Service.map((serviceDetail) => (
//                       <div key={serviceDetail.id}>
//                       <InfoRow>
//                         <FaArrowRight />
//                         {serviceDetail.service_name}
//                       </InfoRow>
//                       <InfoRow>
//                         {sreq.job_information}
//                       </InfoRow>
//                       </div>                      
//                     ))
//                   ) : sreq.Service ? (
//                     <div key={sreq.Service.id}>
//                     <InfoRow>
//                       <FaArrowRight />
//                       {sreq.Service.service_name}
//                     </InfoRow>
//                     <InfoRow>
//                       {sreq.job_information}
//                     </InfoRow>
//                     </div>
//                   ) : null}
//                 </DescriptionContainer>
//               ))}

//               <ActionIconsContainer>
//               <ActionButton 
//                   onClick={() => navigate(`/leads/view/${lead.id}`)}
//                   title="View Details"
//                 >
//                   <FaEye />
//                 </ActionButton>
                
//                 <ActionButton onClick={() => {
//                   setSelectedLead(lead);
//                   setSmsModalOpen(true);
//                 }} title="Send SMS">
//                   <FaSms />
//                 </ActionButton>

//                 <ActionButton  onClick={() => {
//                   handleCallClick(lead);
//                   }}
//                   title="Call"
//                 >
//                   <FaPhoneAlt />
//                 </ActionButton>

//                 <ActionButton 
//                   onClick={() => navigate(`/leads/edit/${lead.id}`)}
//                   title="Edit"
//                 >
//                   <FaEdit />
//                 </ActionButton>

//                 <ActionButton 
//                   onClick={() => {
//                     setLeadToDelete(lead.id);
//                     setDeleteModalOpen(true);
//                   }}
//                   title="Delete"
//                 >
//                   <FaTrash />
//                 </ActionButton>
//               </ActionIconsContainer>
//             </Card>
//           ))
//         )}
//       </GridContainer>
//       </>
//       )}

//       {!loading && filteredLeads.length > itemsPerPage && (
//         <Pagination
//           itemsPerPage={itemsPerPage}
//           totalItems={filteredLeads.length}
//           paginate={(pageNumber) => setCurrentPage(pageNumber)}
//           currentPage={currentPage}
//         />
//       )}

//       {smsModalOpen && (
//         <SmsModal 
//           isOpen={smsModalOpen}  
//           onClose={() => {
//             setSmsModalOpen(false);
//             setSelectedLead(null);
//           }} 
//           lead={selectedLead} 
//           userId={userId}
//         />
//       )}

//       {callModalOpen && leadToCall && (
//         <CallModal
//           isOpen={callModalOpen}
//           onClose={() => {
//             setCallModalOpen(false);
//             setLeadToCall(null);
//           }}
//           customerPhone={leadToCall.phone}
//           customerName={leadToCall.name}
//           leadId={leadToCall.id}
//           onCallSuccess={handleCallSuccess}
//         />
//       )}

//       {deleteModalOpen && (
//         <Modal
//           message="Are you sure you want to delete this lead?"
//           onConfirm={handleDelete}
//           onCancel={() => {
//             setDeleteModalOpen(false);
//             setLeadToDelete(null);
//           }}
//           title="Confirm Delete"
//           isOpen={deleteModalOpen}
//         />
//       )}

//       {/* ModalNotification for feedback */}
//       <FeedbackModal
//         isOpen={showFeedback}
//         message={feedbackMessage}
//         success={feedbackSuccess}
//         duration={5000}
//         onComplete={handleFeedbackComplete}
//       />
//     </DashboardLayout>
//   );
// };

// export default LeadList;




// src/modules/leads/LeadList.js
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import {
  FaEdit, FaTrash, FaSms, FaPhoneAlt, FaMapMarkerAlt, FaBuilding,
  FaInbox, FaSortAlphaDown, FaSortAlphaUp, FaSort, FaEye,
  FaArrowRight, FaEnvelope, FaCalendarAlt, FaFileInvoiceDollar,
  FaChevronDown, FaChevronUp, FaFilter, FaTimes, FaSearch, FaPlus,
  FaList, FaMap, FaColumns, FaStickyNote, FaClock, FaCircle, FaComment
} from 'react-icons/fa';
import { getLeads, deleteLead, getLeadNotes } from './leadService';
import Pagination from '../../components/shared/Pagination';
import Modal from '../../components/shared/Modal';
import DashboardLayout from '../../layouts/DashboardLayout';
import formatPhone from '../../components/shared/formatPhone';
import SmsModal from './SmsModal';
import ModalNotification from '../../components/shared/ModalNotification';
import FeedbackModal from '../../components/shared/ModalNotification'; // Import ModalNotification
import {
  GridContainer, Card, CardHeader, LeadName, CardContent, InfoRow,
  ActionIconsContainer, ActionButton, EmptyState, DescriptionContainer
} from '../../components/styled/GridComponents';
import LoadingSpinner from '../../components/shared/LoadingSpinner';
import CallModal from '../../components/shared/CallModal';
import OriginBadge from '../../components/shared/OriginBadge';
import PreferredContactBadge from '../../components/shared/PreferredContactBadge';
import { formatDate } from '../../utils/utils';
import styled from 'styled-components';
import LeadMapView from './LeadMapView';

// Additional styled components for enhanced UI
// ── Header ──
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${p => p.theme.spacing(2)};
  margin-bottom: ${p => p.theme.spacing(2)};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const Title = styled.h1`
  color: ${p => p.theme.colors.primary};
  margin: 0;
  white-space: nowrap;
  font-size: 1.4rem;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 20px;
  background: ${p => p.theme.colors.primary};
  color: ${p => p.theme.colors.black};
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.88rem;
  white-space: nowrap;
  transition: opacity 0.15s;
  &:hover { opacity: 0.9; }

  @media (max-width: 768px) { width: 100%; }
`;

// ── Search bar ──
const SearchBar = styled.div`
  display: flex;
  align-items: center;
  background: ${p => p.theme.colors.surface};
  border: 1.5px solid ${p => p.theme.colors.inputGray}55;
  border-radius: 24px;
  padding: 0 14px;
  margin-bottom: ${p => p.theme.spacing(2)};
  transition: border-color 0.2s;

  &:focus-within {
    border-color: ${p => p.theme.colors.primary};
  }

  svg { color: ${p => p.theme.colors.inputGray}; flex-shrink: 0; }

  input {
    flex: 1;
    padding: 12px 10px;
    background: transparent;
    border: none;
    color: ${p => p.theme.colors.textPrimary};
    font-size: 0.95rem;
    &:focus { outline: none; }
    &::placeholder { color: ${p => p.theme.colors.inputGray}; }
  }

  .clear-btn {
    background: none;
    border: none;
    color: ${p => p.theme.colors.inputGray};
    cursor: pointer;
    padding: 4px;
    display: flex;
    &:hover { color: ${p => p.theme.colors.textPrimary}; }
  }
`;

// ── Filter toolbar (the toggle row) ──
const FilterToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: ${p => p.theme.spacing(1)};
  margin-bottom: ${p => p.theme.spacing(1.5)};
  flex-wrap: wrap;
`;

const FilterToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: ${p => p.$open ? p.theme.colors.primary + '22' : p.theme.colors.surface};
  color: ${p => p.$open ? p.theme.colors.primary : p.theme.colors.textSecondary};
  border: 1.5px solid ${p => p.$open ? p.theme.colors.primary : p.theme.colors.inputGray}44;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 500;
  transition: all 0.15s;
  &:hover { border-color: ${p => p.theme.colors.primary}88; }
`;

const FilterBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: ${p => p.theme.colors.primary};
  color: ${p => p.theme.colors.black};
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
`;

const ResultCount = styled.span`
  color: ${p => p.theme.colors.textSecondary};
  font-size: 0.82rem;
  margin-left: auto;

  strong { color: ${p => p.theme.colors.textPrimary}; font-weight: 600; }
`;

const ClearAllBtn = styled.button`
  background: none;
  border: none;
  color: ${p => p.theme.colors.error};
  font-size: 0.8rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  &:hover { background: ${p => p.theme.colors.error}18; }
`;

// ── Filter panel (collapsible) ──
const FilterPanel = styled.div`
  overflow: ${p => p.$open ? 'visible' : 'hidden'};
  max-height: ${p => p.$open ? '600px' : '0'};
  opacity: ${p => p.$open ? 1 : 0};
  transition: max-height 0.3s ease, opacity 0.2s ease;
  margin-bottom: ${p => p.$open ? p.theme.spacing(2) : '0'};
  position: relative;
  z-index: 10;
`;

const FilterPanelInner = styled.div`
  background: ${p => p.theme.colors.surface};
  border-radius: 12px;
  padding: ${p => p.theme.spacing(2.5)};
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.spacing(2.5)};
`;

const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FilterRowLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${p => p.theme.colors.textSecondary};
`;

const PillScroller = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border-radius: 20px;
  border: 1.5px solid ${p =>
    p.$active
      ? (p.$color || p.theme.colors.primary)
      : p.theme.colors.inputGray + '44'};
  background: ${p =>
    p.$active
      ? (p.$color || p.theme.colors.primary) + '22'
      : 'transparent'};
  color: ${p =>
    p.$active
      ? (p.$color || p.theme.colors.primary)
      : p.theme.colors.textSecondary};
  font-size: 0.82rem;
  font-weight: ${p => p.$active ? 600 : 400};
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    border-color: ${p => (p.$color || p.theme.colors.primary)}88;
    background: ${p => (p.$color || p.theme.colors.primary)}11;
  }

  svg { font-size: 0.55rem; }
`;

const SortPill = styled(Pill)`
  svg { font-size: 0.78rem; }
`;

// ── City searchable select ──
const CitySelectWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 320px;
`;

const CitySelectInput = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  background: ${p => p.theme.colors.background};
  border: 1.5px solid ${p => p.$open ? p.theme.colors.primary : p.theme.colors.inputGray + '44'};
  border-radius: 20px;
  cursor: pointer;
  transition: border-color 0.15s;

  svg { color: ${p => p.theme.colors.inputGray}; flex-shrink: 0; font-size: 0.82rem; }

  input {
    flex: 1;
    background: transparent;
    border: none;
    color: ${p => p.theme.colors.textPrimary};
    font-size: 0.85rem;
    outline: none;
    min-width: 0;
    &::placeholder { color: ${p => p.theme.colors.inputGray}; }
  }

  .selected-label {
    flex: 1;
    font-size: 0.85rem;
    color: ${p => p.theme.colors.textPrimary};
  }

  .clear-city {
    background: none;
    border: none;
    color: ${p => p.theme.colors.inputGray};
    cursor: pointer;
    padding: 2px;
    display: flex;
    &:hover { color: ${p => p.theme.colors.textPrimary}; }
  }
`;

const CityDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: ${p => p.theme.colors.surface};
  border: 1.5px solid ${p => p.theme.colors.inputGray}55;
  border-radius: 12px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 20;
  box-shadow: 0 8px 24px rgba(0,0,0,0.35);
  -webkit-overflow-scrolling: touch;
`;

const CityOption = styled.div`
  padding: 10px 16px;
  font-size: 0.85rem;
  color: ${p => p.$active ? p.theme.colors.primary : p.theme.colors.textPrimary};
  background: ${p => p.$active ? p.theme.colors.primary + '18' : 'transparent'};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.1s;

  &:hover { background: ${p => p.theme.colors.primary}12; }

  svg {
    font-size: 0.7rem;
    color: ${p => p.$active ? p.theme.colors.primary : p.theme.colors.inputGray};
  }
`;

// ── Active filter chips ──
const ActiveChips = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: ${p => p.theme.spacing(1.5)};
`;

const ActiveChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px 4px 12px;
  background: ${p => (p.$color || p.theme.colors.primary) + '22'};
  border: 1px solid ${p => (p.$color || p.theme.colors.primary) + '44'};
  color: ${p => p.$color || p.theme.colors.primary};
  border-radius: 16px;
  font-size: 0.78rem;
  font-weight: 500;

  button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    display: flex;
    padding: 0;
    opacity: 0.7;
    &:hover { opacity: 1; }
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: ${p => p.theme.spacing(0.5)} ${p => p.theme.spacing(1)};
  border-radius: 12px;
  font-size: ${p => p.theme.typography.fontSize.small};
  background-color: ${p => p.color}22;
  color: ${p => p.color};
`;

const ExpandableCard = styled(Card)`
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const ExpandButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.colors.primary};
  cursor: pointer;
  padding: ${props => props.theme.spacing(1)};
  margin-top: ${props => props.theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(0.5)};
  font-size: ${props => props.theme.typography.fontSize.small};
  
  &:hover {
    text-decoration: underline;
  }
`;

const ExpandedContent = styled.div`
  padding-top: ${props => props.theme.spacing(2)};
  margin-top: ${props => props.theme.spacing(2)};
  border-top: 1px solid ${props => props.theme.colors.inputGray}33;
`;

const SectionTitle = styled.h4`
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.fontSize.small};
  margin: ${props => props.theme.spacing(1)} 0;
`;

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(1)};
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.theme.spacing(1)};
  background: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.borderRadius};
  
  &:hover {
    background: ${props => props.theme.colors.background}aa;
  }
  
  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing(1)};
    
    &:hover {
      text-decoration: underline;
    }
  }
`;


const ViewTabs = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: ${props => props.theme.spacing(3)};
  background: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.borderRadius};
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.inputGray}33;
  width: fit-content;
`;

const ViewTab = styled.button`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(1.5)} ${props => props.theme.spacing(3)};
  background: ${props => props.isActive ? props.theme.colors.primary : 'transparent'};
  color: ${props => props.isActive ? props.theme.colors.black : props.theme.colors.textSecondary};
  border: none;
  cursor: pointer;
  font-weight: ${props => props.isActive ? '600' : '400'};
  font-size: ${props => props.theme.typography.fontSize.medium};
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.isActive ? props.theme.colors.primary : props.theme.colors.primary + '22'};
    color: ${props => props.isActive ? props.theme.colors.black : props.theme.colors.primary};
  }
`;

// Get lead status with fallback to service request status
const getLeadStatus = (lead) => {
  if (lead.status?.status_name) return lead.status;
  const srStatus = lead.serviceRequests?.[0]?.LeadStatus;
  if (srStatus) return srStatus;
  return null;
};

const PIPELINE_STAGES = [
  { key: 'new', label: 'New', color: '#4FC3F7' },
  { key: 'first_contact', label: 'First Contact', color: '#81C784' },
  { key: 'quote_sent', label: 'Quote Sent', color: '#FFB74D' },
  { key: 'quote_opened', label: 'Quote Opened', color: '#FF8A65' },
  { key: 'follow_up_1', label: '1st Follow Up', color: '#BA68C8' },
  { key: 'follow_up_2', label: '2nd Follow Up', color: '#9575CD' },
  { key: 'follow_up_3', label: '3rd Follow Up', color: '#7986CB' },
  { key: 'won', label: 'Won', color: '#66BB6A' },
  { key: 'lost', label: 'Lost', color: '#ef5350' },
];

const getPipelineConfig = (stage) =>
  PIPELINE_STAGES.find(s => s.key === stage) || PIPELINE_STAGES[0];

const PipelineBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: ${props => props.theme.typography.fontSize.small};
  background: ${props => props.color}22;
  color: ${props => props.color};

  svg { font-size: 0.5rem; }
`;

const PipelineDateLabel = styled.span`
  font-size: 0.72rem;
  color: ${props => props.theme.colors.textSecondary};
  margin-left: 4px;
`;

const UpdatedAtRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: ${props => props.theme.colors.textSecondary};
  margin-top: ${props => props.theme.spacing(1)};

  svg { font-size: 0.7rem; }
`;

const NoteItem = styled.div`
  padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(1.5)};
  background: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.borderRadius};
  margin-bottom: ${props => props.theme.spacing(0.5)};

  .note-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;
  }

  .note-action {
    font-size: 0.78rem;
    font-weight: 600;
    color: ${props => props.theme.colors.primary};
  }

  .note-date {
    font-size: 0.72rem;
    color: ${props => props.theme.colors.textSecondary};
  }

  .note-text {
    font-size: 0.82rem;
    color: ${props => props.theme.colors.textPrimary};
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

const LeadList = ({ userId }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize state from URL search params so filters survive navigation
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [leadToDelete, setLeadToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState(searchParams.get('q') || '');
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(parseInt(searchParams.get('page'), 10) || 1);
  const [itemsPerPage] = useState(12);
  const [smsModalOpen, setSmsModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: searchParams.get('sortField') || 'createdAt',
    direction: searchParams.get('sortDir') || 'desc'
  });
  const [statusFilter, setStatusFilter] = useState(searchParams.get('status') || 'all');
  const [cityFilter, setCityFilter] = useState(searchParams.get('city') || 'all');
  const [hasEstimateFilter, setHasEstimateFilter] = useState(searchParams.get('estimate') || 'all');
  const [availableStatuses, setAvailableStatuses] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);
  const [expandedLeads, setExpandedLeads] = useState(new Set());
  const [expandedNotes, setExpandedNotes] = useState(new Set());
  const [leadNotes, setLeadNotes] = useState({});
  const [activeView, setActiveView] = useState(searchParams.get('view') || 'list');
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);
  const [citySearch, setCitySearch] = useState('');
  const citySelectRef = useRef(null);

  // NEW: State for CallModal
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [leadToCall, setLeadToCall] = useState(null);

  // ModalNotification state
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackSuccess, setFeedbackSuccess] = useState(true);

  // Sync filter state to URL search params so back navigation and refresh
  // restore them.
  //
  // Only this page's own keys are touched — LeadMapView owns the `m`-prefixed
  // ones and writes them independently. Rebuilding the params from scratch here
  // would wipe the map's filters on the next keystroke.
  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    const apply = (key, value, omitWhen) =>
      (value === undefined || value === null || value === '' || value === omitWhen)
        ? params.delete(key)
        : params.set(key, String(value));

    apply('q', searchQuery);
    apply('status', statusFilter, 'all');
    apply('city', cityFilter, 'all');
    apply('estimate', hasEstimateFilter, 'all');
    apply('sortField', sortConfig.field, 'createdAt');
    apply('sortDir', sortConfig.direction, 'desc');
    apply('page', currentPage > 1 ? currentPage : '');
    apply('view', activeView, 'list');

    // No-op guard: writing an identical query string creates a new location,
    // which would re-trigger this effect.
    if (params.toString() !== searchParams.toString()) {
      setSearchParams(params, { replace: true });
    }
  }, [searchQuery, statusFilter, cityFilter, hasEstimateFilter, sortConfig,
      currentPage, activeView, searchParams, setSearchParams]);

  // Close city dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (citySelectRef.current && !citySelectRef.current.contains(e.target)) {
        setCityDropdownOpen(false);
        setCitySearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  // Function to show notifications using ModalNotification
  const showNotification = (message, isSuccess = true) => {
    setFeedbackMessage(message);
    setFeedbackSuccess(isSuccess);
    setShowFeedback(true);
  };

  const handleFeedbackComplete = () => {
    setShowFeedback(false);
  };

  // Click-to-call handlers
  const handleCallInitiated = (callData) => {
    showNotification('Call initiated! Your phone will ring momentarily.', true);
  };

  const handleCallError = (error) => {
    showNotification(`Call failed: ${error.message}`, false);
  };

  useEffect(() => {
    const fetchLeads = async () => {
      setLoading(true);
      setError(null);
      try {
        const leadsData = await getLeads();
        setLeads(leadsData);
        setFilteredLeads(leadsData);
        
        // Extract available statuses and cities
        if (leadsData.length > 0) {
          const statuses = new Set(leadsData.map(lead =>
            getLeadStatus(lead)?.status_name || 'No Status'
          ));
          setAvailableStatuses(['all', ...Array.from(statuses)]);
          
          const cities = new Set(leadsData.map(lead => lead.city).filter(Boolean));
          setAvailableCities(['all', ...Array.from(cities)]);
        }
      } catch (error) {
        console.error('Error fetching leads:', error);
        setError('Failed to load leads. Please try again.');
        showNotification('Failed to load leads. Please try again.', false);
      } finally {
        setLoading(false);
      }
    };
    fetchLeads();
  }, []);

  useEffect(() => {
    if (!leads) return;

    // Apply all filters
    let filtered = leads.filter((lead) => {
      // Search filter (match name, email, phone, or city)
      const searchLower = searchQuery.toLowerCase();
      const matchesSearch =
        (lead.name?.toLowerCase().includes(searchLower) ||
         lead.email?.toLowerCase().includes(searchLower) ||
         lead.city?.toLowerCase().includes(searchLower) ||
         lead.phone?.includes(searchLower));

      // Status filter
      const leadStatus = getLeadStatus(lead);
      const matchesStatus =
        statusFilter === 'all' ||
        (statusFilter === 'No Status' && !leadStatus?.status_name) ||
        leadStatus?.status_name === statusFilter;

      // City filter
      const matchesCity =
        cityFilter === 'all' || cityFilter === '' ||
        lead.city === cityFilter;

      // Estimate filter
      const hasEstimate = lead.estimates && lead.estimates.length > 0;
      const matchesEstimate =
        hasEstimateFilter === 'all' ||
        (hasEstimateFilter === 'with' && hasEstimate) ||
        (hasEstimateFilter === 'without' && !hasEstimate);

      return matchesSearch && matchesStatus && matchesCity && matchesEstimate;
    });

    setFilteredLeads(filtered);
  }, [searchQuery, statusFilter, cityFilter, hasEstimateFilter, leads]);

  // Reset to page 1 only when the user actually changes a filter — not on
  // mount or when `leads` arrives from the API (which would blow away a
  // page number restored from the URL).
  const isFirstFilterRun = useRef(true);
  useEffect(() => {
    if (isFirstFilterRun.current) {
      isFirstFilterRun.current = false;
      return;
    }
    setCurrentPage(1);
  }, [searchQuery, statusFilter, cityFilter, hasEstimateFilter]);

  const handleDelete = async () => {
    try {
      await deleteLead(leadToDelete);
      const updatedLeads = await getLeads();
      setLeads(updatedLeads);
      setFilteredLeads(updatedLeads);
      showNotification('Lead deleted successfully.', true);
    } catch (error) {
      showNotification('Failed to delete lead. Please try again.', false);
    } finally {
      setDeleteModalOpen(false);
      setLeadToDelete(null);
    }
  };

  // NEW: Handle call button click
  const handleCallClick = (lead) => {
    setLeadToCall(lead);
    setCallModalOpen(true);
  };

  // NEW: Handle successful call initiation
  const handleCallSuccess = (callResult) => {
    console.log('Call initiated successfully:', callResult);
    // Optionally show a success notification here
  };

  // Toggle expanded state for a lead
  const toggleExpandLead = (id) => {
    setExpandedLeads(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  // Toggle notes for a lead — fetch on first expand
  const toggleNotes = async (leadId) => {
    setExpandedNotes(prev => {
      const newSet = new Set(prev);
      if (newSet.has(leadId)) {
        newSet.delete(leadId);
      } else {
        newSet.add(leadId);
      }
      return newSet;
    });
    if (!leadNotes[leadId]) {
      try {
        const notes = await getLeadNotes(leadId);
        setLeadNotes(prev => ({ ...prev, [leadId]: notes }));
      } catch (err) {
        console.error('Error loading notes for lead', leadId, err);
        setLeadNotes(prev => ({ ...prev, [leadId]: [] }));
      }
    }
  };

  const filteredAndSortedLeads = useMemo(() => {
    return [...filteredLeads].sort((a, b) => {
      let aValue, bValue;
      
      switch (sortConfig.field) {
        case 'name':
          aValue = a.name || '';
          bValue = b.name || '';
          break;
        case 'city':
          aValue = a.city || '';
          bValue = b.city || '';
          break;
        case 'status':
          aValue = a.status?.status_name || 'No Status';
          bValue = b.status?.status_name || 'No Status';
          break;
        case 'createdAt':
          // Convert dates to timestamps for comparison
          return sortConfig.direction === 'desc' 
            ? new Date(b.createdAt) - new Date(a.createdAt)
            : new Date(a.createdAt) - new Date(b.createdAt);
        default:
          aValue = a[sortConfig.field] || '';
          bValue = b[sortConfig.field] || '';
      }

      if (sortConfig.direction === 'asc') {
        return aValue.toString().localeCompare(bValue.toString());
      } else {
        return bValue.toString().localeCompare(aValue.toString());
      }
    });
  }, [filteredLeads, sortConfig]);

  const currentLeads = filteredAndSortedLeads.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSort = (field) => {
    setSortConfig(prevConfig => ({
      field,
      direction: prevConfig.field === field && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };
  
  const clearFilters = () => {
    setSearchQuery('');
    setStatusFilter('all');
    setCityFilter('all');
    setHasEstimateFilter('all');
    setSortConfig({ field: 'createdAt', direction: 'desc' });
    setCurrentPage(1);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'New': return '#3d5afe';
      case 'Prospect': return '#f39c12';
      case 'Estimate Sent': return '#3498db';
      case 'Converted': return '#27ae60';
      case 'Won': return '#9b59b6';
      case 'Customer': return '#28a745';
      case 'Lost': return '#e74c3c';
      case 'Imported': return '#9C27B0';
      case 'In Progress': return '#f9a825';
      case 'Completed': return '#4caf50';
      case 'Accepted': return '#27ae60';
      case 'Declined': return '#e74c3c';
      case 'Sent': return '#3498db';
      case 'Viewed': return '#2ecc71';
      case 'Scheduled': return '#27ae60';
      case 'Draft': return '#f39c12';
      case 'No Status': return '#95a5a6';
      default: return '#95a5a6';
    }
  };

  const activeFilters = [
    statusFilter !== 'all' && { type: 'status', value: statusFilter },
    cityFilter !== 'all' && cityFilter !== '' && { type: 'city', value: cityFilter },
    hasEstimateFilter !== 'all' && { 
      type: 'estimate', 
      value: hasEstimateFilter === 'with' ? 'With Estimate' : 'Without Estimate' 
    },
    searchQuery && { type: 'search', value: searchQuery }
  ].filter(Boolean);

  const removeFilter = (type) => {
    switch (type) {
      case 'status':
        setStatusFilter('all');
        break;
      case 'city':
        setCityFilter('all');
        break;
      case 'estimate':
        setHasEstimateFilter('all');
        break;
      case 'search':
        setSearchQuery('');
        break;
    }
  };

  return (
    <DashboardLayout>
      {/* Header */}
      <HeaderContainer>
        <Title>Leads</Title>
        <AddButton onClick={() => navigate('/leads/new')}>
          <FaPlus /> New Lead
        </AddButton>
      </HeaderContainer>

      {/* Search */}
      <SearchBar>
        <FaSearch />
        <input
          type="text"
          placeholder="Search name, email, phone, city..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button className="clear-btn" onClick={() => setSearchQuery('')}>
            <FaTimes />
          </button>
        )}
      </SearchBar>

      {/* View Tabs */}
      <ViewTabs>
        <ViewTab isActive={activeView === 'list'} onClick={() => setActiveView('list')}>
          <FaList /> List
        </ViewTab>
        <ViewTab isActive={activeView === 'map'} onClick={() => setActiveView('map')}>
          <FaMap /> Map
        </ViewTab>
        <ViewTab isActive={false} onClick={() => navigate('/leads/pipeline')}>
          <FaColumns /> Pipeline
        </ViewTab>
      </ViewTabs>

      {loading ? (
        <LoadingSpinner />
      ) : activeView === 'map' ? (
        <LeadMapView leads={leads} />
      ) : (
        <>
          {/* Filter toolbar */}
          <FilterToolbar>
            <FilterToggleBtn
              $open={filterPanelOpen}
              onClick={() => setFilterPanelOpen(v => !v)}
            >
              <FaFilter />
              Filters
              {activeFilters.length > 0 && <FilterBadge>{activeFilters.length}</FilterBadge>}
            </FilterToggleBtn>

            {activeFilters.length > 0 && (
              <ClearAllBtn onClick={clearFilters}>
                <FaTimes /> Clear all
              </ClearAllBtn>
            )}

            <ResultCount>
              <strong>{filteredLeads.length}</strong> lead{filteredLeads.length !== 1 ? 's' : ''}
            </ResultCount>
          </FilterToolbar>

          {/* Active filter chips — always visible */}
          {activeFilters.length > 0 && (
            <ActiveChips>
              {activeFilters.map((filter, i) => (
                <ActiveChip
                  key={i}
                  $color={filter.type === 'status' ? getStatusColor(filter.value) : undefined}
                >
                  {filter.type === 'search' && 'Search: '}
                  {filter.value}
                  <button onClick={() => removeFilter(filter.type)}><FaTimes /></button>
                </ActiveChip>
              ))}
            </ActiveChips>
          )}

          {/* Collapsible filter panel */}
          <FilterPanel $open={filterPanelOpen}>
            <FilterPanelInner>
              {/* Sort */}
              <FilterRow>
                <FilterRowLabel>Sort by</FilterRowLabel>
                <PillScroller>
                  {[
                    { field: 'createdAt', label: 'Date' },
                    { field: 'name', label: 'Name' },
                    { field: 'city', label: 'City' },
                  ].map(s => (
                    <SortPill
                      key={s.field}
                      $active={sortConfig.field === s.field}
                      onClick={() => handleSort(s.field)}
                    >
                      {sortConfig.field === s.field
                        ? (sortConfig.direction === 'asc' ? <FaSortAlphaDown /> : <FaSortAlphaUp />)
                        : <FaSort />}
                      {s.label}
                    </SortPill>
                  ))}
                </PillScroller>
              </FilterRow>

              {/* Status */}
              <FilterRow>
                <FilterRowLabel>Status</FilterRowLabel>
                <PillScroller>
                  <Pill
                    $active={statusFilter === 'all'}
                    onClick={() => setStatusFilter('all')}
                  >
                    All
                  </Pill>
                  {availableStatuses.filter(s => s !== 'all').map(status => (
                    <Pill
                      key={status}
                      $active={statusFilter === status}
                      $color={getStatusColor(status)}
                      onClick={() => setStatusFilter(statusFilter === status ? 'all' : status)}
                    >
                      <FaCircle /> {status}
                    </Pill>
                  ))}
                </PillScroller>
              </FilterRow>

              {/* City — searchable select */}
              <FilterRow>
                <FilterRowLabel>City</FilterRowLabel>
                <CitySelectWrapper ref={citySelectRef}>
                  <CitySelectInput
                    $open={cityDropdownOpen}
                    onClick={() => {
                      setCityDropdownOpen(prev => !prev);
                      setCitySearch('');
                    }}
                  >
                    <FaMapMarkerAlt />
                    {cityDropdownOpen ? (
                      <input
                        autoFocus
                        placeholder="Type to search..."
                        value={citySearch}
                        onChange={(e) => setCitySearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : (
                      <span className="selected-label">
                        {cityFilter === 'all' ? 'All Cities' : cityFilter}
                      </span>
                    )}
                    {cityFilter !== 'all' && !cityDropdownOpen && (
                      <button
                        className="clear-city"
                        onClick={(e) => { e.stopPropagation(); setCityFilter('all'); }}
                      >
                        <FaTimes />
                      </button>
                    )}
                    {!cityDropdownOpen ? <FaChevronDown style={{ fontSize: '0.65rem' }} /> : <FaChevronUp style={{ fontSize: '0.65rem' }} />}
                  </CitySelectInput>
                  {cityDropdownOpen && (
                    <CityDropdown>
                      <CityOption
                        $active={cityFilter === 'all'}
                        onClick={() => { setCityFilter('all'); setCityDropdownOpen(false); setCitySearch(''); }}
                      >
                        All Cities
                      </CityOption>
                      {availableCities
                        .filter(c => c !== 'all')
                        .filter(c => c.toLowerCase().includes(citySearch.toLowerCase()))
                        .map(city => (
                          <CityOption
                            key={city}
                            $active={cityFilter === city}
                            onClick={() => { setCityFilter(city); setCityDropdownOpen(false); setCitySearch(''); }}
                          >
                            <FaMapMarkerAlt /> {city}
                          </CityOption>
                        ))}
                      {availableCities
                        .filter(c => c !== 'all')
                        .filter(c => c.toLowerCase().includes(citySearch.toLowerCase()))
                        .length === 0 && (
                          <CityOption as="div" style={{ color: '#787878', cursor: 'default' }}>
                            No cities match
                          </CityOption>
                        )}
                    </CityDropdown>
                  )}
                </CitySelectWrapper>
              </FilterRow>

              {/* Estimate */}
              <FilterRow>
                <FilterRowLabel>Estimates</FilterRowLabel>
                <PillScroller>
                  {[
                    { value: 'all', label: 'All' },
                    { value: 'with', label: 'Has Estimate' },
                    { value: 'without', label: 'No Estimate' },
                  ].map(opt => (
                    <Pill
                      key={opt.value}
                      $active={hasEstimateFilter === opt.value}
                      $color={opt.value === 'with' ? '#66BB6A' : opt.value === 'without' ? '#ef5350' : undefined}
                      onClick={() => setHasEstimateFilter(opt.value)}
                    >
                      {opt.value === 'with' && <FaFileInvoiceDollar />}
                      {opt.label}
                    </Pill>
                  ))}
                </PillScroller>
              </FilterRow>
            </FilterPanelInner>
          </FilterPanel>

          <GridContainer>
            {loading ? (
              [...Array(6)].map((_, index) => (
                <Card key={index} isLoading>
                  <CardContent />
                </Card>
              ))
            ) : currentLeads.length === 0 ? (
              <EmptyState>
                <FaInbox size={48} />
                <p>No leads found. Try adjusting your search or add a new lead.</p>
              </EmptyState>
            ) : (
              currentLeads.map((lead) => {
                const isExpanded = expandedLeads.has(lead.id);
                const hasEstimates = lead.estimates && lead.estimates.length > 0;
                
                return (
                  <ExpandableCard key={lead.id}>
                    <CardHeader>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', minWidth: 0 }}>
                        <LeadName>{lead.name}</LeadName>
                        {lead.origin?.origin_name && (
                          <OriginBadge origin={lead.origin} size="sm" />
                        )}
                        <PreferredContactBadge value={lead.preferred_contact} size="sm" />
                      </div>
                      <StatusBadge color={
                        getLeadStatus(lead)?.color ||
                        getStatusColor(getLeadStatus(lead)?.status_name || "No Status")
                      }>
                        {getLeadStatus(lead)?.status_name || "No Status"}
                      </StatusBadge>
                    </CardHeader>

                    <CardContent>
                      <InfoRow>
                        <FaMapMarkerAlt />
                        <span>{lead.city || 'No city'}</span>
                      </InfoRow>
                      
                      <InfoRow>
                        <FaPhoneAlt />
                        <span>{formatPhone(lead.phone)}</span>
                      </InfoRow>
                      
                      {lead.email && (
                        <InfoRow>
                          <FaEnvelope />
                          <span>{lead.email}</span>
                        </InfoRow>
                      )}

                      {/* Pipeline stage badge */}
                      {(() => {
                        const pipelineStage = lead.pipeline_stage || 'new';
                        const pConfig = getPipelineConfig(pipelineStage);
                        const stageDate = lead.pipeline_dates?.[pipelineStage];
                        return (
                          <InfoRow>
                            <PipelineBadge color={pConfig.color}>
                              <FaCircle /> {pConfig.label}
                            </PipelineBadge>
                            {stageDate && (
                              <PipelineDateLabel>
                                {new Date(stageDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                              </PipelineDateLabel>
                            )}
                          </InfoRow>
                        );
                      })()}

                      {/* Last updated date */}
                      {lead.updatedAt && (
                        <UpdatedAtRow>
                          <FaClock />
                          Updated {new Date(lead.updatedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                        </UpdatedAtRow>
                      )}

                      {lead.serviceRequests?.length > 0 && (
                        <DescriptionContainer>
                          {lead.serviceRequests.map((sreq) => (
                            <div key={sreq.id}>
                              <InfoRow>
                                <FaArrowRight />
                                {sreq.Service?.service_name || 'Unknown Service'}
                              </InfoRow>
                              {sreq.job_information && (
                                <InfoRow>
                                  {sreq.job_information}
                                </InfoRow>
                              )}
                            </div>                      
                          ))}
                        </DescriptionContainer>
                      )}
                      
                      <ExpandButton onClick={() => toggleExpandLead(lead.id)}>
                        {isExpanded ? (
                          <>Show Less <FaChevronUp /></>
                        ) : (
                          <>Show More <FaChevronDown /></>
                        )}
                      </ExpandButton>
                      
                      {isExpanded && (
                        <ExpandedContent>
                          {/* Estimates section */}
                          <SectionTitle>
                            <FaFileInvoiceDollar /> Estimates
                          </SectionTitle>
                          <ItemList>
                            {lead.estimates && lead.estimates.length > 0 ? (
                              lead.estimates.map(est => (
                                <ItemRow key={`estimate-${est.id}`}>
                                  <a href={`/estimates/view/${est.id}`}>
                                    <FaFileInvoiceDollar /> Estimate #{est.id}
                                  </a>
                                  <StatusBadge color={getStatusColor(est.status || 'Draft')}>
                                    {est.status || 'Draft'}
                                  </StatusBadge>
                                </ItemRow>
                              ))
                            ) : (
                              <div style={{ color: '#aaa', fontStyle: 'italic' }}>
                                No estimates found
                              </div>
                            )}
                          </ItemList>

                          {/* Jobs section */}
                          <SectionTitle>
                            <FaCalendarAlt /> Scheduled Jobs
                          </SectionTitle>
                          <ItemList>
                            {lead.jobs && lead.jobs.length > 0 ? (
                              lead.jobs.map(job => (
                                <ItemRow key={`job-${job.job_id}`}>
                                  <a href={`/jobs/${job.job_id}`}>
                                    <FaCalendarAlt /> Job on {formatDate(job.scheduled_start_date)}
                                  </a>
                                  <StatusBadge color={getStatusColor(job.status)}>
                                    {job.status}
                                  </StatusBadge>
                                </ItemRow>
                              ))
                            ) : (
                              <div style={{ color: '#aaa', fontStyle: 'italic' }}>
                                No jobs scheduled
                              </div>
                            )}
                          </ItemList>

                          {/* Notes section */}
                          <ExpandButton onClick={() => toggleNotes(lead.id)}>
                            {expandedNotes.has(lead.id) ? (
                              <><FaComment /> Hide Notes <FaChevronUp /></>
                            ) : (
                              <><FaComment /> Show Notes <FaChevronDown /></>
                            )}
                          </ExpandButton>
                          {expandedNotes.has(lead.id) && (
                            <ItemList>
                              {!leadNotes[lead.id] ? (
                                <div style={{ color: '#aaa', fontStyle: 'italic', padding: '4px 0' }}>Loading...</div>
                              ) : leadNotes[lead.id].length === 0 ? (
                                <div style={{ color: '#aaa', fontStyle: 'italic', padding: '4px 0' }}>No notes yet</div>
                              ) : (
                                leadNotes[lead.id].slice(0, 3).map(note => (
                                  <NoteItem key={note.id}>
                                    <div className="note-header">
                                      <span className="note-action">{note.action || 'Note'}</span>
                                      <span className="note-date">
                                        {new Date(note.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                      </span>
                                    </div>
                                    <div className="note-text">{note.description}</div>
                                  </NoteItem>
                                ))
                              )}
                            </ItemList>
                          )}
                        </ExpandedContent>
                      )}
                    </CardContent>

                    <ActionIconsContainer>
                      <ActionButton
                        as={Link}
                        to={`/leads/view/${lead.id}`}
                        title="View Details"
                      >
                        <FaEye />
                      </ActionButton>

                      <ActionButton onClick={() => {
                        setSelectedLead(lead);
                        setSmsModalOpen(true);
                      }} title="Send SMS">
                        <FaSms />
                      </ActionButton>

                      <ActionButton onClick={() => {
                        handleCallClick(lead);
                      }}
                        title="Call"
                      >
                        <FaPhoneAlt />
                      </ActionButton>

                      <ActionButton
                        as={Link}
                        to={`/leads/edit/${lead.id}`}
                        title="Edit"
                      >
                        <FaEdit />
                      </ActionButton>

                      <ActionButton 
                        onClick={() => {
                          setLeadToDelete(lead.id);
                          setDeleteModalOpen(true);
                        }}
                        title="Delete"
                      >
                        <FaTrash />
                      </ActionButton>
                    </ActionIconsContainer>
                  </ExpandableCard>
                );
              })
            )}
          </GridContainer>
        </>
      )}

      {!loading && filteredLeads.length > itemsPerPage && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={filteredLeads.length}
          paginate={(pageNumber) => setCurrentPage(pageNumber)}
          currentPage={currentPage}
        />
      )}

      {smsModalOpen && (
        <SmsModal 
          isOpen={smsModalOpen}  
          onClose={() => {
            setSmsModalOpen(false);
            setSelectedLead(null);
          }} 
          lead={selectedLead} 
          userId={userId}
        />
      )}

      {callModalOpen && leadToCall && (
        <CallModal
          isOpen={callModalOpen}
          onClose={() => {
            setCallModalOpen(false);
            setLeadToCall(null);
          }}
          customerPhone={leadToCall.phone}
          customerName={leadToCall.name}
          leadId={leadToCall.id}
          onCallSuccess={handleCallSuccess}
        />
      )}

       {deleteModalOpen && (
        <Modal
          message="Are you sure you want to delete this lead?"
          onConfirm={handleDelete}
          onCancel={() => {
            setDeleteModalOpen(false);
            setLeadToDelete(null);
          }}
          title="Confirm Delete"
          isOpen={deleteModalOpen}
        />
      )}

      {/* ModalNotification for feedback */}
      <FeedbackModal
        isOpen={showFeedback}
        message={feedbackMessage}
        success={feedbackSuccess}
        onComplete={handleFeedbackComplete}
      />
    </DashboardLayout>
  );
};

export default LeadList;
